import React, { useState, useEffect, useRef } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Row, Col, Modal, Button, Table, Form } from "react-bootstrap";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";  // Import your configured axios instance
import useAuth from "../../hooks/useAuth";
import { useConsignmentTypes, useShippingModes } from "../../utils/Utilities.js";
import { useNavigate, Link } from "react-router-dom";
const BOOK_CONSIGNMENT = "api/book-consignment";
const ADD_CONSIGNMENT = "api/add-consignment";

const Booking = () => {

    const navigate = useNavigate();
    const [weight, setWeight] = useState("0.100");
    const [pieces, setPieces] = useState("1");
    const [remarks, setRemarks] = useState("");

    const [custType, setCustType] = useState("");


    const axiosPrivate = useAxiosPrivate();
    const { auth } = useAuth();

    const [bookingType, setBookingType] = useState("courier"); // default

    const [customerOptions, setCustomerOptions] = useState([]);
    const [customer, setCustomer] = useState("");
    const [customerId, setCustomerId] = useState(null);

    const [postOffices, setPostOffices] = useState({});

    const [totalVol, setTotalVol] = useState(0);

    const [volDivisor, setVolDivisor] = useState("");
    const [errors, setErrors] = useState({});

    const [Customer_Name, setCustomer_Name] = useState("");
    const [loading, setLoading] = useState(false);

    const [isCustomerSelected, setIsCustomerSelected] = useState(false);

    const handleInputChange = (e) => {
        setCustomer_Name(e.target.value);
        setIsCustomerSelected(false); // allow searching again
    };




    useEffect(() => {
        const fetchCustomers = async () => {

            // 1️⃣ Stop if customer type is empty or Walk-in
            if (!custType || custType === "WC") {
                setCustomerOptions([]);
                return;
            }

            // 2️⃣ Stop if a customer is already selected
            if (isCustomerSelected) {
                setCustomerOptions([]);
                return;
            }

            // 3️⃣ Stop if search box is empty
            if (!Customer_Name.trim()) {
                setCustomerOptions([]);
                return;
            }

            try {
                setLoading(true);

                const response = await axiosPrivate.get(
                    "api/list-booking-customers",
                    {
                        params: {
                            customer_type: custType,
                            franchise_id: auth.franchise_id,
                            search_text: Customer_Name
                        }
                    }
                );

                // 4️⃣ If API success, set dropdown options
                if (response.status === 200 && Array.isArray(response.data)) {
                    setCustomerOptions(response.data);
                } else {
                    setCustomerOptions([]);
                }

            } catch (error) {
                console.error("Error fetching customers:", error);
                setCustomerOptions([]);
            } finally {
                setLoading(false);
            }
        };

        // 5️⃣ Delay API call (debounce)
        const debounceTimer = setTimeout(fetchCustomers, 400);

        // 6️⃣ Cleanup old timer when user types again
        return () => clearTimeout(debounceTimer);

    }, [Customer_Name, custType, auth.franchise_id, isCustomerSelected]);










    const getDefaultRow = (bookingType) => ({
        pincode: "",
        pincode_id: "",
        destCity: "",
        awb_number: "",
        weight: "0.100",
        pieces: "1",
        volume: "",
        consignmentType:
            bookingType === "courier" || bookingType === "premium"
                ? "DX"
                : bookingType === "logistics"
                    ? "NX"
                    : "",
        shippingMode:
            bookingType === "courier"
                ? "XP"
                : bookingType === "premium"
                    ? "XP"
                    : bookingType === "logistics" || bookingType === "CargoBox" || bookingType === "International"
                        ? "SF"
                        : "",
        consignerName: "",
        consignerMobile: "",
        consignerEmail: "",
        consigneeName: "",
        consigneeMobile: "",
        consigneeEmail: "",

        cod_value: "",
        fov_value: "",
        obd_value: "",

        remarks: "",
    });

    const [bookingRows, setBookingRows] = useState([getDefaultRow(bookingType)]);


    const handleRowChange = (index, field, value) => {
        const updatedRows = [...bookingRows];
        updatedRows[index][field] = value;
        setBookingRows(updatedRows);
    };



    const handleAddBookingRow = () => {
        setBookingRows((prev) => [...prev, getDefaultRow(bookingType)]);
    };






    const [currentDate, setCurrentDate] = useState("");
    const [currentTime, setCurrentTime] = useState("");

    useEffect(() => {
        const now = new Date();

        // Format date as YYYY-MM-DD for <input type="date">
        const formattedDate = now.toISOString().split("T")[0];
        setCurrentDate(formattedDate);

        // Format time as HH:MM:SS for <input type="time" step="1">
        const hours = String(now.getHours()).padStart(2, "0");
        const minutes = String(now.getMinutes()).padStart(2, "0");
        const seconds = String(now.getSeconds()).padStart(2, "0");
        setCurrentTime(`${hours}:${minutes}:${seconds}`);
    }, []);




    // 👉 Save handler
    const handleSave = (index) => {
        const row = bookingRows[index];
        console.log("Saving row:", row);

        // filter selected payment modes
        const selectedPayments = Object.keys(paymentModes).filter(
            (key) => paymentModes[key]
        );

    };



    const [consignmentType, setConsignmentType] = useState("");
    const [shippingMode, setShippingMode] = useState("");
    const [consignerName, setConsignerName] = useState(" ");

    const [consigneeName, setConsigneeName] = useState("");
    const [consigneeMobile, setConsigneeMobile] = useState("");




    useEffect(() => {
        if (bookingType === "courier" || bookingType === "premium") {
            setConsignmentType("DX"); // default
        } else if (bookingType === "logistics") {
            setConsignmentType("NX");
        } else if (bookingType === "CargoBox") {
            setConsignmentType(""); // ✅ reset correctly
        } else if (bookingType === "International") {
            setConsignmentType(""); // ✅ reset correctly
        }

    }, [bookingType]);


    useEffect(() => {
        if (bookingType === "courier") {
            setShippingMode("XP"); // default for courier
        } else if (bookingType === "premium") {
            setShippingMode("XP"); // only XP available
        } else if (bookingType === "logistics" || bookingType === "CargoBox" || bookingType === "International") {
            setShippingMode("SF"); // default for logistics & CargoBox
        }
    }, [bookingType]);

    const [paymentModes, setPaymentModes] = useState({
        service_type: {
            REGULAR: false,
            EDL: false,
            ODA: false,
            NONSERVICABLE: false,
        },
        delivery_mode: "", // single selection
    });


    // For service_type (multiple checkboxes)
    const handleServiceTypeChange = (type) => {
        setPaymentModes((prev) => ({
            ...prev,
            service_type: {
                ...prev.service_type,
                [type]: !prev.service_type[type],
            },
        }));
    };

    // For delivery_mode (single radio)
    const handleDeliveryModeChange = (mode) => {
        setPaymentModes((prev) => ({
            ...prev,
            delivery_mode: mode,
        }));
    };


    const [responseMessage, setResponseMessage] = useState("");
    const handleBookingSubmit = async (index) => {
        handleSave(index);


        if (repPCS) {
            console.log("REP PCS is selected");
        } else {
            console.log("REP PCS is NOT selected");
        }

        // 🚨 Validate dimensions (LBH)
        if (
            !LBH ||
            LBH.length === 0 ||
            LBH.some(
                (d) =>
                    !d.length || !d.breadth || !d.height ||
                    Number(d.length) <= 0 ||
                    Number(d.breadth) <= 0 ||
                    Number(d.height) <= 0
            )
        ) {
            alert("Please enter valid VOL WT  Length, Breadth, and Height values greater than 0 before saving.");
            return;
        }

        const selectedPayments = Object.keys(paymentModes).filter(
            (key) => paymentModes[key]
        );

        const dateObj = new Date(currentDate);
        const formattedDate = dateObj.toLocaleDateString("en-GB");

        const consignment = {
            consignee_mobile: bookingRows[index].consigneeMobile,
            consignment_type: bookingRows[index].consignmentType,
            shipping_mode: bookingRows[index].shippingMode,
            consignee_name: bookingRows[index].consigneeName,
            consignee_city: bookingRows[index].destCity || "",
            pincode_id: bookingRows[index].pincode_id || "",
            destination_franchise_id: bookingRows[index].franchise_id || null,
            sector: "DOMESTIC",
            goods_name: "Documents",
            pieces: bookingRows[index].pieces || "",
            weight: bookingRows[index].weight || "",
            amount: 30,
            remarks: bookingRows[index].remarks || "",
            goods_value: 1,
            cod_value: bookingRows[index].COD || null,
            fov_value: bookingRows[index].FOV || null,
            obd_value: bookingRows[index].OBD || null,
            topay_value: bookingRows[index].TOPAY || null,
            divisor: Number(volDivisor),
            dimensions: LBH,
        };

        // ✅ Only include awb_number if present
        if (bookingRows[index].awb_number) {
            consignment.awb_number = bookingRows[index].awb_number;
        }

        const payload = {
            franchise_id: auth.franchise_id,
            service_type: Object.keys(paymentModes.service_type).filter(
                (key) => paymentModes.service_type[key]
            ),
            delivery_mode: paymentModes.delivery_mode,
            // booking_type:
            //     bookingType === "courier"
            //         ? "Courier Booking"
            //         : bookingType === "premium"
            //             ? "Premium Booking"
            //             : "Logistics Booking",
            booking_type:
                bookingType === "courier"
                    ? "Courier Booking"
                    : bookingType === "premium"
                        ? "Premium Booking"
                        : bookingType === "logistics"
                            ? "Logistics Booking"
                            : bookingType === "CargoBox"
                                ? "Cargo Box Booking"
                                : bookingType === "International"
                                    ? "International Booking"
                                    : "",

            consigner_name: consignerName,
            booking_date: formattedDate,
            net_amount: 120,
            customer_id: customerId || null,
            payment_mode: paymentMode,
            consignments: [consignment],
        };

        console.log("payload:", JSON.stringify(payload, null, 2));

        try {
            const response = await axiosPrivate.post(BOOK_CONSIGNMENT, payload);
            console.log("Response:", response.data);
            setResponseMessage(response.data);
            // setBookingRows([...bookingRows, getDefaultRow(bookingType)]);
            // Create new blank row
            const newRow = getDefaultRow(bookingType);

            // If REP PCS is selected → copy PCS from current row
            if (repPCS) {
                const pcsValue = bookingRows[index].pieces;

                // 1️⃣ Update new row pieces
                newRow.pieces = pcsValue;

                // 2️⃣ Update the default pieces variable
                setPieces(pcsValue);

                console.log("REP PCS → copying PCS =", pcsValue);
            }

            // Add new row
            setBookingRows([...bookingRows, newRow]);



        } catch (error) {
            if (error.response) {
                console.error("Error:", error.response.data.message);
                setResponseMessage({ message: error.response.data.message });
            } else {
                console.error("Error:", error.message);
                setResponseMessage({ message: "An unexpected error occurred." });
            }
        }
    };




    const handleAddConsignment = async (index) => {
        // ✅ First, call your handleSave logic
        handleSave(index);

        // 🚨 Validate dimensions (LBH)
        if (
            !LBH ||
            LBH.length === 0 ||
            LBH.some(
                (d) =>
                    !d.length || !d.breadth || !d.height ||
                    Number(d.length) <= 0 ||
                    Number(d.breadth) <= 0 ||
                    Number(d.height) <= 0
            )
        ) {
            alert("Please enter valid Length, Breadth, and Height values greater than 0 before saving.");
            return;
        }



        // ✅ Collect selected payments
        const selectedPayments = Object.keys(paymentModes).filter(
            (key) => paymentModes[key]
        );

        // Convert to Date object
        const dateObj = new Date(currentDate);

        // Format to dd/mm/yyyy
        const formattedDate = dateObj.toLocaleDateString("en-GB");

        // ✅ Build base payload (without awb_number)
        const add_consignment_payload = {
            booking_id: responseMessage.booking_id,
            consignment_type: bookingRows[index].consignmentType,
            shipping_mode: bookingRows[index].shippingMode,
            consignee_mobile: bookingRows[index].consigneeMobile,
            consignee_name: bookingRows[index].consigneeName,
            consignee_address1: "",
            consignee_address2: "",
            consignee_city: bookingRows[index].destCity || "",
            pincode_id: bookingRows[index].pincode_id || "",
            destination_franchise_id: bookingRows[index].franchise_id || null,
            sector: "DOMESTIC",
            goods_name: "Documents",
            goods_value: 1,
            eway_bill_nos: "",
            pieces: bookingRows[index].pieces,
            weight: bookingRows[index].weight,
            amount: 30,
            gst: null,
            other_charges: 20,
            remarks: bookingRows[index].remarks,
            // consignee_email: null,
            cod_value: bookingRows[index].COD || null,
            fov_value: bookingRows[index].FOV || null,
            obd_value: bookingRows[index].OBD || null,
            topay_value: bookingRows[index].TOPAY || null,
            divisor: Number(volDivisor),
            dimensions: LBH,
        };

        // ✅ Add awb_number ONLY if it's valid
        const awbValue = bookingRows[index].awb_number;
        if (awbValue) {
            add_consignment_payload.awb_number = awbValue;
        }

        console.log(
            "ADD_CONSIGNMENT_payload:",
            JSON.stringify(add_consignment_payload, null, 2)
        );

        // ✅ API call
        try {
            const response = await axiosPrivate.post(
                ADD_CONSIGNMENT,
                add_consignment_payload
            );
            console.log("Response:", response.data);
            setResponseMessage(response.data);

            // ✅ Add new row after successful submit
            // setBookingRows([...bookingRows, getDefaultRow(bookingType)]);
            // Create new blank row
            const newRow = getDefaultRow(bookingType);

            // If REP PCS is selected → copy PCS from current row
            if (repPCS) {
                const pcsValue = bookingRows[index].pieces;

                // 1️⃣ Update new row pieces
                newRow.pieces = pcsValue;

                // 2️⃣ Update the default pieces variable
                setPieces(pcsValue);

                console.log("REP PCS → copying PCS =", pcsValue);
            }

            // Add new row
            setBookingRows([...bookingRows, newRow]);
        } catch (error) {
            if (error.response) {
                console.error("Error:", error.response.data.message);
                setResponseMessage({ message: error.response.data.message });
            } else {
                console.error("Error:", error.message);
                setResponseMessage({ message: "An unexpected error occurred." });
            }
        }
    };

    const [error, setError] = useState("");
    const [isRegularDisabled, setIsRegularDisabled] = useState(false);





    // const pincodeHandleKeyDown = async (e, index) => {
    //     if (e.key !== "Enter" || e.target.value.trim() === "") return;

    //     const pincode = e.target.value.trim();

    //     try {
    //         // ✅ MAIN API
    //         let response = await axiosPrivate.get("/api/list-serviceareas", {
    //             params: { pincode }
    //         });

    //         // ✅ 204 → fallback
    //         if (response.status === 204) {
    //             setIsRegularDisabled(true);
    //             setPaymentModes(prev => ({
    //                 ...prev,
    //                 service_type: {
    //                     ...prev.service_type,
    //                     REGULAR: false,
    //                 },
    //             }));

    //             const fallbackRes = await axiosPrivate.get("/api/list-postoffice", {
    //                 params: { pincode }
    //             });

    //             const data = fallbackRes.data;

    //             if (Array.isArray(data) && data.length > 0) {
    //                 setPostOffices(prev => ({
    //                     ...prev,
    //                     [index]: data
    //                 }));

    //                 const firstPO = data[0];

    //                 setBookingRows(prev => {
    //                     const updated = [...prev];
    //                     updated[index] = {
    //                         ...updated[index],
    //                         destCity: firstPO.post_office,
    //                         pincode_id: firstPO.pincode_id,
    //                         pincode: firstPO.pincode,
    //                         district: firstPO.district,
    //                         state: firstPO.state || "",
    //                         franchise_name: null,
    //                         franchise_id: null,
    //                         collection: firstPO.collection,
    //                         delivery: firstPO.delivery,
    //                         on_demand: firstPO.on_demand,
    //                     };
    //                     return updated;
    //                 });
    //             } else {
    //                 alert(`${pincode} Pincode doesn’t exist.`);
    //             }

    //             return;
    //         }

    //         // ✅ MAIN API success
    //         setIsRegularDisabled(false);

    //         const data = response.data;

    //         if (Array.isArray(data) && data.length > 0) {
    //             const franchise = data[0];
    //             const postOfficeList = franchise.postoffices || [];

    //             if (!postOfficeList.length) {
    //                 alert("No post offices found.");
    //                 return;
    //             }

    //             setPostOffices(prev => ({
    //                 ...prev,
    //                 [index]: postOfficeList
    //             }));

    //             const firstPO = postOfficeList[0];

    //             setBookingRows(prev => {
    //                 const updated = [...prev];
    //                 updated[index] = {
    //                     ...updated[index],
    //                     destCity: firstPO.post_office,
    //                     pincode_id: firstPO.pincode_id,
    //                     pincode: firstPO.pincode,
    //                     district: firstPO.district,
    //                     state: franchise.state,
    //                     franchise_name: franchise.franchise_name,
    //                     franchise_id: franchise.franchise_id,
    //                     collection: firstPO.collection,
    //                     delivery: firstPO.delivery,
    //                     on_demand: firstPO.on_demand,
    //                 };
    //                 return updated;
    //             });
    //         } else {
    //             alert(`${pincode} Pincode doesn’t exist.`);
    //         }

    //     } catch (err) {
    //         console.error("Error:", err);
    //         alert("Error fetching pincode details");
    //     }
    // };



    const pincodeHandleKeyDown = async (e, index) => {
        if (e.key !== "Enter" || !e.target.value.trim()) return;

        const pincode = e.target.value.trim();

        try {
            /* ============================
               1️⃣ MAIN API : serviceareas
            ============================ */
            const response = await axiosPrivate.get("/api/list-serviceareas", {
                params: { pincode }
            });

            /* ============================
               2️⃣ FALLBACK : 204 → postoffice
            ============================ */
            if (response.status === 204) {

                // 🚫 Disable REGULAR
                setIsRegularDisabled(true);
                setPaymentModes(prev => ({
                    ...prev,
                    service_type: {
                        ...prev.service_type,
                        REGULAR: false,
                    },
                }));

                // 🚫 Mark pincode as unassigned
                setUnassignedPincode(prev => ({
                    ...prev,
                    [index]: true
                }));

                // 🚫 Clear Destination Franchises for this row
                setDestinationFranchises(prev => ({
                    ...prev,
                    [index]: []
                }));

                // 🔁 Fallback → postoffice
                const fallbackRes = await axiosPrivate.get("/api/list-postoffice", {
                    params: { pincode }
                });

                const data = fallbackRes.data;

                if (!Array.isArray(data) || data.length === 0) {
                    alert(`${pincode} Pincode doesn’t exist.`);
                    return;
                }

                setPostOffices(prev => ({
                    ...prev,
                    [index]: data
                }));

                const firstPO = data[0];

                setBookingRows(prev => {
                    const updated = [...prev];
                    updated[index] = {
                        ...updated[index],
                        pincode: firstPO.pincode,
                        pincode_id: firstPO.pincode_id,
                        destCity: firstPO.post_office,
                        district: firstPO.district,
                        state: firstPO.state || "",
                        franchise_id: null,
                        franchise_name: "Pincode unassigned",
                        collection: firstPO.collection,
                        delivery: firstPO.delivery,
                        on_demand: firstPO.on_demand,
                    };
                    return updated;
                });

                return;
            }


            /* ============================
               3️⃣ MAIN API SUCCESS
            ============================ */
            setIsRegularDisabled(false);

            const data = response.data;

            if (!Array.isArray(data) || data.length === 0) {
                alert(`${pincode} Pincode doesn’t exist.`);
                return;
            }


            /* ✅ RESET unassigned flag HERE */
            setUnassignedPincode(prev => ({
                ...prev,
                [index]: false
            }));

            // ✅ store all Destination Franchises for this row
            setDestinationFranchises(prev => ({
                ...prev,
                [index]: data
            }));

            const firstFranchise = data[0];
            const postOfficeList = firstFranchise.postoffices || [];

            if (postOfficeList.length === 0) {
                alert("No post offices found.");
                return;
            }

            // ✅ store post offices of first franchise
            setPostOffices(prev => ({
                ...prev,
                [index]: postOfficeList
            }));

            const firstPO = postOfficeList[0];

            // ✅ update booking row
            setBookingRows(prev => {
                const updated = [...prev];
                updated[index] = {
                    ...updated[index],
                    pincode: firstPO.pincode,
                    pincode_id: firstPO.pincode_id,
                    destCity: firstPO.post_office,
                    district: firstPO.district,
                    state: firstFranchise.state,
                    franchise_id: firstFranchise.franchise_id,
                    franchise_name: firstFranchise.franchise_name,
                    collection: firstPO.collection,
                    delivery: firstPO.delivery,
                    on_demand: firstPO.on_demand,
                };
                return updated;
            });

        } catch (err) {
            console.error("Error fetching pincode details:", err);
            alert("Error fetching pincode details");
        }
    };


    const [ShowFinalConfirmModal, setShowFinalConfirmModal] = useState(false);
    const [paymentMode, setPaymentMode] = useState("Cash"); // default value
    const handleCloseFinalConfirmModal = () => setShowFinalConfirmModal(false);


    const firstInputRef = useRef(null);

    useEffect(() => {
        if (ShowFinalConfirmModal && firstInputRef.current) {
            // Optional: small delay ensures modal fully rendered before focus
            setTimeout(() => firstInputRef.current.focus(), 100);
        }
    }, [ShowFinalConfirmModal]);



    const handleShowModal = async (index) => {
        setSelectedRowIndex(index);
        const pcs = bookingRows[index].pieces || "1";
        console.log("pcs :", pcs);
        setShowFinalConfirmModal(true);

    };



    // Keep track of LBH
    const [LBH, setLBH] = useState([
        { slno: 1, length: "", breadth: "", height: "" },
    ]);

    // Handle input changes
    const handleChange = (index, field, value) => {
        const newLBH = [...LBH];
        newLBH[index][field] = value;
        setLBH(newLBH);
    };


    // Submit
    const LBH_Submit = () => {
        const newErrors = {};

        // 1️⃣ Validate LBH rows
        LBH.forEach((item, index) => {
            if (!item.length) newErrors[`${index}-length`] = true;
            if (!item.breadth) newErrors[`${index}-breadth`] = true;
            if (!item.height) newErrors[`${index}-height`] = true;
        });

        // 2️⃣ Validate divisor
        if (!volDivisor) {
            newErrors["divisor"] = true;
        }

        // 3️⃣ Stop submit if errors exist
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        // 4️⃣ Clear errors once valid
        setErrors({});

        // ✅ YOUR EXISTING LOGIC (UNCHANGED)
        const total = LBH.reduce((sum, item) => {
            const l = parseFloat(item.length);
            const b = parseFloat(item.breadth);
            const h = parseFloat(item.height);
            return sum + (l * b * h);
        }, 0);

        const finalVolume = total / volDivisor;

        console.log("Total Volume :", total);
        console.log("Divided Volume :", finalVolume);

        setTotalVol(finalVolume);

        if (selectedRowIndex !== null) {
            setBookingRows((prevRows) => {
                const updated = [...prevRows];
                updated[selectedRowIndex].volume = finalVolume.toFixed(2);
                return updated;
            });
        }

        handleCloseFinalConfirmModal();
    };







    useEffect(() => {
        if (ShowFinalConfirmModal && selectedRowIndex !== null) {
            const pcs = parseInt(bookingRows[selectedRowIndex]?.pieces || "1");
            setLBH((prevLBH) => {
                if (prevLBH.length !== pcs) {
                    return Array.from({ length: pcs }, (_, i) => ({
                        slno: i + 1,
                        length: "",
                        breadth: "",
                        height: ""
                    }));
                }
                return prevLBH;
            });
        }

    }, [ShowFinalConfirmModal, pieces]);



    const [selectedRowIndex, setSelectedRowIndex] = useState(null);

    const [options, setOptions] = useState([]);
    useEffect(() => {
        axiosPrivate
            .get("/api/list-customertypes") // 🔁 replace with your actual API URL
            .then((response) => {
                setOptions(response.data);
            })
            .catch((error) => {
                console.error("Error fetching customer types:", error);
            });
    }, []);

    useEffect(() => {
        const interval = setInterval(() => {
            const now = new Date();

            // Auto update date (yyyy-mm-dd)
            setCurrentDate(now.toISOString().split("T")[0]);

            // Auto update time (hh:mm:ss)
            setCurrentTime(
                now.toLocaleTimeString("en-GB", { hour12: false }) // 24-hour with seconds
            );
        }, 1000); // update every 1 second

        return () => clearInterval(interval); // cleanup
    }, []);

    const [repPCS, setRepPCS] = useState(false);


    const { consignmentTypes } = useConsignmentTypes();
    const { shippingModes } = useShippingModes();

    const handleRedirect2 = () => {
        navigate("/GetBookConsignmentByDate");
    }

    useEffect(() => {
        if (custType) {
            console.log("Customer Type updated:", custType);
        }
    }, [custType]);

    const CustomerHandleSelect = (customer) => {
        setCustomerId(customer.id);        // store customer.id
        setCustomer_Name(customer.name);   // keep name in input
        setCustomerOptions([]);             // close dropdown
        setIsCustomerSelected(true);         // stop re-search
    };


    const [DestinationFranchises, setDestinationFranchises] = useState({});
    const [unassignedPincode, setUnassignedPincode] = useState({});


    return (
        <>

            <section className="servicenewbody">
                <div className="wrapper10">
                    <div className="d-flex align-items-center">
                        {/* Left */}
                        <button
                            onClick={() => navigate(-1)}
                            className="btn btn-secondary newviewbtn"
                        >
                            ← Back
                        </button>

                        {/* Right */}
                        <div className="d-flex gap-2 ms-auto">
                            <button
                                onClick={handleRedirect2}
                                type="button"
                                className="btn btn-success top-bt"
                            >
                                Consignment List
                            </button>

                        </div>
                    </div>
                    <h3>Booking</h3>

                    <Row>
                        <Col md={9}>
                            <div className='newboarder'>
                                <div className="container py-4">
                                    {/* Booking Type */}
                                    <div className="mb-3 ">

                                        <div className="form-check form-check-inline">
                                            <input
                                                className="form-check-input  ms-0"
                                                type="radio"
                                                name="bookingType"
                                                checked={bookingType === "courier"}
                                                onChange={() => setBookingType("courier")}
                                            />
                                            <label className="form-check-label ms-1 newstyleradio">Courier</label>
                                        </div>

                                        <div className="form-check form-check-inline">
                                            <input
                                                className="form-check-input  ms-0"
                                                type="radio"
                                                name="bookingType"
                                                checked={bookingType === "premium"}
                                                onChange={() => setBookingType("premium")}
                                            />
                                            <label className="form-check-label ms-1 newstyleradio">Premium</label>
                                        </div>

                                        <div className="form-check form-check-inline">
                                            <input
                                                className="form-check-input  ms-0"
                                                type="radio"
                                                name="bookingType"
                                                checked={bookingType === "logistics"}
                                                onChange={() => setBookingType("logistics")}
                                            />
                                            <label className="form-check-label ms-1 newstyleradio">Logistics</label>
                                        </div>

                                        <div className="form-check form-check-inline">
                                            <input
                                                className="form-check-input  ms-0"
                                                type="radio"
                                                name="bookingType"
                                                checked={bookingType === "CargoBox"}
                                                onChange={() => setBookingType("CargoBox")}
                                            />
                                            <label className="form-check-label ms-1 newstyleradio">Cargo Box</label>
                                        </div>

                                        <div className="form-check form-check-inline">
                                            <input
                                                className="form-check-input  ms-0"
                                                type="radio"
                                                name="bookingType"
                                                checked={bookingType === "International"}
                                                onChange={() => setBookingType("International")}
                                            />
                                            <label className="form-check-label ms-1 newstyleradio">International</label>
                                        </div>
                                        {/* <div className="form-check form-check-inline m-0">
                      <input className="form-check-input " type="radio" name="bookingType" defaultChecked />
                      <label className="form-check-label ms-1 newstyleradio">Courier Booking</label>
                    </div>
                      <div className="form-check form-check-inline m-0">
                      <input className="form-check-input" type="radio" name="bookingType" />
                      <label className="form-check-label ms-1 newstyleradio">Premium Booking</label>
                    </div>
                     <div className="form-check form-check-inline m-0">
                      <input className="form-check-input" type="radio" name="bookingType" />
                      <label className="form-check-label ms-1 newstyleradio">Logistics Booking</label>
                    </div> */}
                                        <hr className="mt-3 newhr" />
                                    </div>

                                    {/* Form Fields */}
                                    <Row>
                                        <Col>
                                            <div className="newinput-boxs">
                                                <label htmlFor="bookingBranch">Booking Branch</label>

                                                <input
                                                    type="text"
                                                    id="bookingBranch"
                                                    className="form-control"
                                                    value={auth.franchise_name}   // 👈 your fixed value
                                                    disabled                      // 👈 prevents editing
                                                />
                                            </div>

                                        </Col>
                                        <Col>
                                            <div className=" newinput-boxs">
                                                <label htmlFor="email">Booking MFNO  </label>

                                                <input
                                                    type="text"
                                                    id="email"
                                                    autoComplete="off"
                                                    placeholder=""

                                                />
                                                <button
                                                    type="button"
                                                    class="btn btn-success ms-auto d-block top-bt"
                                                    style={{
                                                        fontSize: "14px",
                                                        padding: "6px 12px",
                                                        borderRadius: "6px",
                                                        marginTop: "0px"
                                                    }} >OLD BFO Number</button>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <div className=" newinput-boxs">
                                                <label htmlFor="email">MFNO Ref  </label>

                                                <input
                                                    type="text"
                                                    id="email"
                                                    autoComplete="off"
                                                    placeholder=""

                                                />
                                            </div>
                                        </Col>
                                        <Col>
                                            <div className=" newinput-boxs">
                                                <label htmlFor="email">MFNO Date time  </label>


                                                {/* Date Picker */}
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    value={currentDate}
                                                    readOnly={auth.role !== "SysAdmin"}
                                                    onChange={(e) => setCurrentDate(e.target.value)}
                                                    style={{ fontSize: '12px' }}
                                                />

                                                <input
                                                    type="time"
                                                    className="form-control mt-2"
                                                    step="1"
                                                    value={currentTime}
                                                    readOnly={auth.role !== "SysAdmin"}
                                                    onChange={(e) => setCurrentTime(e.target.value)}
                                                    style={{ fontSize: '12px' }}
                                                />



                                            </div>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col>
                                            <div className="newinput-boxs">

                                                <label htmlFor="custType">Customer Type</label>

                                                <br />
                                                <select
                                                    className="newregselect"
                                                    id="custType"
                                                    value={custType}
                                                    onChange={(e) => setCustType(e.target.value)}
                                                >
                                                    <option value="">-- Select Customer Type --</option>

                                                    {options.map((item) => (
                                                        <option key={item.value} value={item.value}>
                                                            {item.text} - ({item.value})
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </Col>

                                        <Col>
                                            <div className="newinput-boxs">
                                                <label htmlFor="customer">Customer Name</label>

                                                {custType !== "WC" ? (
                                                    <>
                                                        <input
                                                            type="text"
                                                            id="Customer-name"
                                                            autoComplete="off"
                                                            placeholder="Search Customer"
                                                            onChange={handleInputChange}
                                                            value={Customer_Name}
                                                            style={styles.input}
                                                        />

                                                        {loading && <div className="loader">Searching...</div>}

                                                        {Customer_Name && customerOptions.length > 0 && !isCustomerSelected && (
                                                            <ul style={styles.dropdown}>
                                                                {customerOptions.map((customer) => (
                                                                    <li
                                                                        key={customer.id}
                                                                        onMouseDown={() => CustomerHandleSelect(customer)}
                                                                        style={styles.dropdownItem}
                                                                    >
                                                                        {customer.name} ({customer.address})
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                        )}

                                                    </>
                                                ) : (
                                                    <input
                                                        type="text"
                                                        className="newregselect"
                                                        name="customer"
                                                        id="customer"
                                                        value={consignerName || ""}
                                                        onChange={(e) => setConsignerName(e.target.value)}
                                                        placeholder="Enter customer name"
                                                        autoComplete="off"
                                                    />
                                                )}
                                            </div>
                                        </Col>

                                    </Row>

                                    <label class="form-check-label newstylecheck">Service type</label>
                                    <div className="d-flex flex-wrap gap-3">
                                        {["REGULAR", "EDL", "ODA", "NONSERVICABLE"].map((type) => (
                                            <div className="d-flex align-items-center" key={type}>
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input me-2"
                                                    checked={paymentModes.service_type[type]}
                                                    disabled={type === "REGULAR" && isRegularDisabled} // 👈 disable logic
                                                    onChange={() => handleServiceTypeChange(type)}
                                                />

                                                <label className="form-check-label newstylecheck">
                                                    {type === "NONSERVICABLE" ? "NON SERVICABLE" : type}
                                                </label>
                                            </div>
                                        ))}
                                    </div>

                                    <div className="mt-3">
                                        <label class="form-check-label newstylecheck">Delivery mode</label>
                                        <div className="d-flex flex-wrap gap-3">
                                            {["TOPAY", "COD", "FOV OR", "FOV CR", "OBD"].map((mode) => (
                                                <div className="d-flex align-items-center" key={mode}>
                                                    <input
                                                        type="radio"
                                                        name="delivery_mode"
                                                        className="form-check-input me-2"
                                                        checked={paymentModes.delivery_mode === mode}
                                                        onChange={() => handleDeliveryModeChange(mode)}
                                                    />
                                                    <label className="form-check-label newstylecheck">{mode}</label>
                                                </div>
                                            ))}
                                        </div>
                                    </div>



                                    <div className="mt-3">
                                        <label className="form-check-label newstylecheck">Payment Mode</label>
                                        <div className="d-flex flex-wrap gap-3">
                                            <div className="d-flex align-items-center">
                                                <input
                                                    type="radio"
                                                    name="paymentMode"
                                                    className="form-check-input me-2"
                                                    checked={paymentMode === "Cash"}
                                                    onChange={() => setPaymentMode("Cash")}
                                                />
                                                <label className="form-check-label newstylecheck">Cash</label>
                                            </div>

                                            <div className="d-flex align-items-center">
                                                <input
                                                    type="radio"
                                                    name="paymentMode"
                                                    className="form-check-input me-2"
                                                    checked={paymentMode === "Credit"}
                                                    onChange={() => setPaymentMode("Credit")}
                                                />
                                                <label className="form-check-label newstylecheck">Credit</label>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </Col>
                        <Col md={3}>
                            <div className='newboarder'>
                                <div className="container py-3">
                                    <div className="mb-3 ">
                                        <div className="form-check form-check-inline m-0">
                                            <input className="form-check-input " type="radio" name="bookingType2" defaultChecked />
                                            <label className="form-check-label ms-1 newstyleradio">Regular</label>
                                        </div>
                                        <div className="form-check form-check-inline m-0">
                                            <input className="form-check-input" type="radio" name="bookingType2" />
                                            <label className="form-check-label ms-1 newstyleradio">E-POD</label>
                                        </div>
                                        <hr className="mt-3 newhr" />
                                        <div className="d-flex align-items-center newblocks">
                                            <input type="checkbox" className="form-check-input me-2" />
                                            <label className="form-check-label newstylecheck">
                                                SELECT ALL
                                            </label>
                                        </div>
                                        <div className="d-flex align-items-center newblocks">
                                            <input type="checkbox" className="form-check-input me-2" />
                                            <label className="form-check-label newstylecheck">REFNO</label>
                                        </div>
                                        <div className="d-flex align-items-center newblocks">
                                            <input type="checkbox" className="form-check-input me-2" />
                                            <label className="form-check-label newstylecheck">ADDRESS</label>
                                        </div>
                                        <div className="d-flex align-items-center newblocks">
                                            <input type="checkbox" className="form-check-input me-2" />
                                            <label className="form-check-label newstylecheck">AUTO INCREMENT</label>
                                        </div>
                                        <div className="d-flex align-items-center newblocks">
                                            <input type="checkbox" className="form-check-input me-2" />
                                            <label className="form-check-label newstylecheck">REP WEIGHT</label>
                                        </div>
                                        <div className="d-flex align-items-center newblocks">
                                            <input
                                                type="checkbox"
                                                className="form-check-input me-2"
                                                checked={repPCS}
                                                onChange={() => setRepPCS(!repPCS)}
                                            />
                                            <label className="form-check-label newstylecheck">REP PCS</label>
                                        </div>

                                        <div className="d-flex align-items-center newblocks">
                                            <input type="checkbox" className="form-check-input me-2" />
                                            <label className="form-check-label newstylecheck">REP PINCODE</label>
                                        </div>
                                        <div className="d-flex align-items-center newblocks">
                                            <input type="checkbox" className="form-check-input me-2" />
                                            <label className="form-check-label newstylecheck">REP MODE</label>
                                        </div>
                                        <div className="d-flex align-items-center newblocks">
                                            <input type="checkbox" className="form-check-input me-2" />
                                            <label className="form-check-label newstylecheck">REP DOC</label>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </Col>

                        <div className="mt-3">
                            {responseMessage && (
                                <div className="alert alert-success mt-3" role="alert">
                                    {Array.isArray(responseMessage.message) ? (
                                        <ul>
                                            {responseMessage.message.map((err, idx) => (
                                                <li key={idx}>{err.msg}</li>
                                            ))}
                                        </ul>
                                    ) : (
                                        <>
                                            <strong>{responseMessage.message}</strong>
                                            {responseMessage.booking_id && (
                                                <>
                                                    <br />
                                                    Booking ID: {responseMessage.booking_id}
                                                </>
                                            )}
                                        </>
                                    )}
                                </div>
                            )}



                            {error && <p className="alert alert-danger mt-3">{error}</p>}

                            {/* {postOfficeData && (
                                <div className="alert alert-success mt-3">
                                    <p><strong>Pincode:</strong> {postOfficeData.pincode}</p>
                                    <p><strong>Post Office:</strong> {postOfficeData.post_office}</p>
                                    <p><strong>post_office:</strong> {postOfficeData.post_office}</p>
                                    <p><strong>State:</strong> {postOfficeData.state}</p>
                                </div>
                            )} */}
                        </div>
                        <div className="mt-4">
                            {/* <h5>Destination Details</h5> */}
                            <span className="d-flex justify-content-end gap-2">

                                <button type="button" className="btn btn-primary d-block top-bt" onClick={() => window.location.reload()}>
                                    NEW BOOKING MF
                                </button>
                            </span>
                            <div style={{ overflowX: 'auto' }}>
                                <table border="1" id="customers2">
                                    <thead>
                                        <tr>
                                            <th>SL</th>
                                            <th>DEST PINCODE</th>
                                            <th>DEST CITY</th>
                                            <th>DEST Franchise</th>
                                            <th>AWB</th>
                                            <th>WEIGHT (kg)</th>
                                            <th>PCS (No's)</th>
                                            <th>VOL WT (kg)</th>
                                            {(bookingType === "courier" || bookingType === "premium" || bookingType === "logistics") && (
                                                <th>DOC</th>
                                            )}
                                            <th>MODE</th>
                                            {(bookingType === "premium" || bookingType === "logistics") && (
                                                <>
                                                    <th>CSR DTLS</th>
                                                    <th>CSR MOB</th>
                                                    <th>CSR Email</th>
                                                    <th>CSE DTLS</th>
                                                    <th>CSE MOB</th>
                                                    <th>CSE Email</th>
                                                </>
                                            )}
                                            {(paymentModes.delivery_mode === "FOV OR" ||
                                                paymentModes.delivery_mode === "FOV CR") && (
                                                    <th>FOV</th>
                                                )}
                                            {(paymentModes.delivery_mode === "COD") && (
                                                <th>COD</th>
                                            )}
                                            {(paymentModes.delivery_mode === "OBD") && (
                                                <th>OBD</th>
                                            )}
                                            {(paymentModes.delivery_mode === "TOPAY") && (
                                                <th>TOPAY</th>
                                            )}
                                            <th>REMARKS</th>
                                            <th>ACTION</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {bookingRows.map((row, index) => (
                                            <tr key={index}>
                                                <td>{index + 1}</td>

                                                {/* DEST PINCODE */}
                                                <td>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={row.pincode}
                                                        onChange={(e) => handleRowChange(index, "pincode", e.target.value)}
                                                        onKeyDown={(e) => pincodeHandleKeyDown(e, index)} // ✅ pass index here
                                                    />
                                                </td>


                                                {/* DEST CITY */}
                                                <td>
                                                    {postOffices[index] && postOffices[index].length > 0 ? (
                                                        <select
                                                            className="form-control"
                                                            value={row.pincode_id || postOffices[index][0].pincode_id}
                                                            onChange={(e) => {
                                                                const selectedId = parseInt(e.target.value);
                                                                const selectedPO = postOffices[index].find(po => po.pincode_id === selectedId);

                                                                handleRowChange(index, "pincode_id", selectedId);
                                                                handleRowChange(index, "destCity", selectedPO.post_office);
                                                            }}
                                                        >
                                                            {postOffices[index].map((po) => (
                                                                <option key={po.pincode_id} value={po.pincode_id}>
                                                                    {po.post_office}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    ) : (
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={row.destCity || ""}
                                                            disabled
                                                        />
                                                    )}
                                                </td>

                                                {/* DEST Franchise */}
                                                <td>
                                                    {unassignedPincode[index] ? (
                                                        <input
                                                            type="text"
                                                            className="form-control text-danger"
                                                            value="Unassigned Pincode"
                                                            disabled
                                                        />
                                                    ) : DestinationFranchises[index] && DestinationFranchises[index].length > 0 ? (
                                                        <select
                                                            className="form-control"
                                                            value={row.franchise_id || DestinationFranchises[index][0].franchise_id}
                                                            onChange={(e) => {
                                                                const selectedId = parseInt(e.target.value);
                                                                const selectedFranchise = DestinationFranchises[index].find(
                                                                    f => f.franchise_id === selectedId
                                                                );

                                                                handleRowChange(index, "franchise_id", selectedFranchise.franchise_id);
                                                                handleRowChange(index, "franchise_name", selectedFranchise.franchise_name);
                                                                handleRowChange(index, "state", selectedFranchise.state);

                                                                setPostOffices(prev => ({
                                                                    ...prev,
                                                                    [index]: selectedFranchise.postoffices || []
                                                                }));

                                                                const firstPO = selectedFranchise.postoffices?.[0];
                                                                if (firstPO) {
                                                                    handleRowChange(index, "pincode_id", firstPO.pincode_id);
                                                                    handleRowChange(index, "destCity", firstPO.post_office);
                                                                }
                                                            }}
                                                        >
                                                            {DestinationFranchises[index].map(f => (
                                                                <option key={f.franchise_id} value={f.franchise_id}>
                                                                    {f.franchise_name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    ) : (
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={row.franchise_name || ""}
                                                            disabled
                                                        />
                                                    )}
                                                </td>






                                                {/* AWB */}
                                                <td>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={row.awb_number}
                                                        onChange={(e) => handleRowChange(index, "awb_number", e.target.value)}
                                                    />
                                                </td>

                                                {/* WEIGHT */}
                                                <td>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={row.weight}
                                                        onInput={(e) => {
                                                            e.target.value = e.target.value
                                                                .replace(/[^0-9.]/g, "")
                                                                .replace(/(\..*?)\..*/g, "$1");
                                                        }}
                                                        onChange={(e) => handleRowChange(index, "weight", e.target.value)}
                                                        onBlur={(e) => {
                                                            if (e.target.value === "") handleRowChange(index, "weight", "0.100");
                                                        }}
                                                    />
                                                </td>


                                                {/* PCS */}
                                                <td>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={row.pieces}
                                                        onChange={(e) => {
                                                            const value = e.target.value.replace(/[^0-9]/g, "");
                                                            handleRowChange(index, "pieces", value);

                                                            // 🔹 Clear totalVol and reset the corresponding row.volume
                                                            setTotalVol(0);
                                                            handleRowChange(index, "volume", "");
                                                        }}
                                                        onBlur={(e) => {
                                                            if (e.target.value.trim() === "") {
                                                                handleRowChange(index, "pieces", "1");
                                                            }
                                                        }}
                                                    />
                                                </td>


                                                {/* VOL WT */}
                                                <td
                                                    onClick={() => handleShowModal(index)}
                                                    onKeyDown={(e) => {
                                                        if (e.key === "Enter") handleShowModal(index);
                                                    }}
                                                    style={{ cursor: "pointer" }}
                                                    tabIndex={0} // ✅ makes the cell focusable via keyboard
                                                >
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={row.volume}
                                                        onChange={(e) => handleRowChange(index, "volume", e.target.value)}
                                                        readOnly // ✅ allows clicks but prevents editing
                                                    />
                                                    <span style={{ color: "red", marginLeft: "5px" }}>
                                                        <i className="bx bx-info-circle"></i>
                                                    </span>
                                                </td>



                                                {(bookingType === "courier" ||
                                                    bookingType === "premium" ||
                                                    bookingType === "logistics") && (
                                                        <td>
                                                            <select
                                                                className="form-control"
                                                                value={row.consignmentType}
                                                                onChange={(e) => {
                                                                    const selectedType = e.target.value;

                                                                    const selectedObj = consignmentTypes.find(
                                                                        (item) => item.consignment_type === selectedType
                                                                    );

                                                                    // Store consignment_type (DX / ND)
                                                                    handleRowChange(index, "consignmentType", selectedType);

                                                                    // Optionally store description if needed elsewhere
                                                                    handleRowChange(
                                                                        index,
                                                                        "consignmentDescription",
                                                                        selectedObj?.description || ""
                                                                    );
                                                                }}
                                                            >
                                                                <option value="">-- Select --</option>

                                                                {consignmentTypes.map((item) => (
                                                                    <option
                                                                        key={item.consignment_type}
                                                                        value={item.consignment_type}   // background value
                                                                    >
                                                                        {item.description}              {/* visible text */}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </td>
                                                    )}







                                                {/* MODE (shippingMode) */}
                                                <td>
                                                    <select
                                                        className="form-control"
                                                        value={row.shippingMode}
                                                        onChange={(e) => {
                                                            const selectedValue = e.target.value;

                                                            const selectedMode = shippingModes.find(
                                                                (m) => m.shipping_mode === selectedValue
                                                            );

                                                            // Pass shipping_mode in background
                                                            handleRowChange(index, "shippingMode", selectedValue);

                                                            // Optional: keep description if required elsewhere
                                                            handleRowChange(
                                                                index,
                                                                "shippingDescription",
                                                                selectedMode?.description || ""
                                                            );
                                                        }}
                                                    >
                                                        <option value="">-- Select --</option>

                                                        {shippingModes.map((mode) => (
                                                            <option
                                                                key={mode.shipping_mode}
                                                                value={mode.shipping_mode}   // background value
                                                            >
                                                                {mode.description}           {/* visible text */}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </td>




                                                {/* CSR/CSE Details */}
                                                {(bookingType === "premium" || bookingType === "logistics") && (
                                                    <>
                                                        <td>
                                                            <textarea
                                                                className="form-control"
                                                                value={row.consignerName}
                                                                onChange={(e) => handleRowChange(index, "consignerName", e.target.value)}
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={row.consignerMobile}
                                                                onChange={(e) => handleRowChange(index, "consignerMobile", e.target.value)}
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={row.consignerEmail}
                                                                onChange={(e) => handleRowChange(index, "consignerEmail", e.target.value)}
                                                            />
                                                        </td>
                                                        <td>
                                                            <textarea
                                                                className="form-control"
                                                                value={row.consigneeName}
                                                                onChange={(e) => handleRowChange(index, "consigneeName", e.target.value)}
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={row.consigneeMobile}
                                                                onChange={(e) => handleRowChange(index, "consigneeMobile", e.target.value)}
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={row.consigneeEmail}
                                                                onChange={(e) => handleRowChange(index, "consigneeEmail", e.target.value)}
                                                            />
                                                        </td>
                                                    </>
                                                )}
                                                {(paymentModes.delivery_mode === "FOV OR" ||
                                                    paymentModes.delivery_mode === "FOV CR") && (
                                                        <td>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={row.FOV}
                                                                onChange={(e) => handleRowChange(index, "FOV", e.target.value)}
                                                            />
                                                        </td>
                                                    )}

                                                {(paymentModes.delivery_mode === "COD") && (
                                                    <td>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={row.COD}
                                                            onChange={(e) => handleRowChange(index, "COD", e.target.value)}
                                                        />
                                                    </td>
                                                )}
                                                {(paymentModes.delivery_mode === "OBD") && (
                                                    <td>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={row.OBD}
                                                            onChange={(e) => handleRowChange(index, "OBD", e.target.value)}
                                                        />
                                                    </td>
                                                )}
                                                {(paymentModes.delivery_mode === "TOPAY") && (
                                                    <td>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={row.TOPAY}
                                                            onChange={(e) => handleRowChange(index, "TOPAY", e.target.value)}
                                                        />
                                                    </td>
                                                )}
                                                {/* REMARKS */}
                                                <td>
                                                    <textarea
                                                        className="form-control"
                                                        value={row.remarks}
                                                        onChange={(e) => handleRowChange(index, "remarks", e.target.value)}
                                                    />
                                                </td>

                                                {/* ACTION */}
                                                <td>
                                                    <button
                                                        type="button"
                                                        className="btn btn-success d-block top-bt"
                                                        onClick={() => {
                                                            if (index === 0) {
                                                                handleBookingSubmit(index); // First row → submit
                                                            } else {
                                                                handleAddConsignment(index); // Other rows → update
                                                            }
                                                        }}
                                                    >
                                                        {index === 0 ? "SAVE" : "Add"}
                                                    </button>


                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                        </div>

                    </Row>

                </div >
            </section >
            <Modal
                show={ShowFinalConfirmModal}
                onHide={handleCloseFinalConfirmModal}
                centered
                size="lg"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Enter Dimensions</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div className="modstyle">

                        {/* Moved Apply All Button here */}
                        <div className="d-flex justify-content-end mb-3">
                            <Button
                                variant="warning"
                                size="sm"
                                onClick={() => {
                                    setLBH((prevLBH) => {
                                        if (prevLBH.length === 0) return prevLBH;
                                        const firstRow = prevLBH[0];
                                        return prevLBH.map((row, i) =>
                                            i === 0 ? row : { ...row, length: firstRow.length, breadth: firstRow.breadth, height: firstRow.height }
                                        );
                                    });
                                }}
                            >
                                Apply all
                            </Button>
                        </div>

                        <Table bordered hover responsive>
                            <thead>
                                <tr>
                                    <th>Sl. No</th>
                                    <th>Length</th>
                                    <th>Breadth</th>
                                    <th>Height</th>
                                </tr>
                            </thead>
                            <tbody>
                                {LBH.map((row, index) => (
                                    <tr key={row.slno}>
                                        <td>{row.slno}</td>
                                        <td>


                                            <Form.Control
                                                type="number"
                                                value={row.length}
                                                isInvalid={errors[`${index}-length`]}
                                                onChange={(e) => handleChange(index, "length", e.target.value)}
                                            />



                                        </td>
                                        <td>
                                            <Form.Control
                                                type="number"
                                                value={row.breadth}
                                                isInvalid={errors[`${index}-breadth`]}
                                                onChange={(e) => handleChange(index, "breadth", e.target.value)}
                                            />

                                        </td>
                                        <td>
                                            <Form.Control
                                                type="number"
                                                value={row.height}
                                                isInvalid={errors[`${index}-height`]}
                                                onChange={(e) => handleChange(index, "height", e.target.value)}
                                            />

                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                        <div className="mb-3">
                            <label>Select divisor value</label>
                            <select
                                className={`form-control ${errors.divisor ? "is-invalid" : ""}`}
                                value={volDivisor}
                                onChange={(e) => setVolDivisor(Number(e.target.value))}
                            >

                                <option value="" disabled>
                                    -- Select divisor --
                                </option>
                                <option value={4500}>4500</option>
                                <option value={5000}>5000</option>
                                <option value={6000}>6000</option>
                            </select>
                        </div>



                        <div className="d-flex justify-content-end">
                            <Button
                                className="newbtn"
                                onClick={LBH_Submit}
                                disabled={!volDivisor}
                            >
                                Submit
                            </Button>
                        </div>


                    </div>
                </Modal.Body>

            </Modal>

        </>
    );
};

const styles = {
    container: {
        padding: '40px',
        maxWidth: '500px',
        margin: 'auto',
        fontFamily: 'Arial, sans-serif',
    },
    form: {
        display: 'flex',
        flexDirection: 'column',
        gap: '20px',
    },
    inputWrapper: {
        display: 'flex',
        flexDirection: 'column',
    },
    input: {
        padding: '10px',
        fontSize: '16px',
        border: '1px solid #ccc',
        borderRadius: '4px',
    },
    dropdown: {
        position: 'absolute',
        top: '100%',
        left: 0,
        right: 0,
        zIndex: 1000,
        backgroundColor: '#fff',
        border: '1px solid #ccc',
        borderTop: 'none',
        maxHeight: '200px',
        overflowY: 'auto',
        listStyle: 'none',
        padding: 0,
        margin: 0,
        boxShadow: '0px 2px 6px rgba(0,0,0,0.15)',
    },
    dropdownItem: {
        padding: '10px',
        cursor: 'pointer',
        borderBottom: '1px solid #eee',
        color: '#000',          // force black
        backgroundColor: '#fff' // ensure contrast
    },
    button: {
        padding: '10px 15px',
        backgroundColor: '#007bff',
        color: '#fff',
        border: 'none',
        borderRadius: '4px',
        fontSize: '16px',
        cursor: 'pointer',
    },


};

export default Booking;







